import Vue from "vue";
import {
  format,
  formatDistance,
  formatDistanceStrict,
  parseISO,
  differenceInYears,
  differenceInMonths,
  differenceInDays,
} from "date-fns";
import dateFnsEsp from "date-fns/locale/es";

Vue.filter("formatDateAndTime", function (value) {
  return value ? format(parseISO(value), "dd/MM/yyyy HH:mm") : "";
});

Vue.filter("formatDate", function (value) {
  return value ? format(parseISO(value), "dd/MM/yyyy") : "N/A";
});

Vue.filter("time", function (value) {
  return value ? format(parseISO(value), "HH:mm") : "";
});

Vue.filter("age", function (value) {
  if (!value) {
    return "N/A";
  }

  const birthDate = parseISO(new Date(value).toISOString());
  const now = new Date();

  const years = differenceInYears(now, birthDate);
  const totalMonths = differenceInMonths(now, birthDate);
  const remainingMonths = totalMonths - years * 12;
  const days = differenceInDays(now, birthDate);

  if (years > 0 && remainingMonths > 0) {
    return `${years} año${years !== 1 ? "s" : ""} ${remainingMonths} mes${
      remainingMonths !== 1 ? "es" : ""
    }`;
  }
  if (years > 0) {
    return `${years} año${years !== 1 ? "s" : ""}`;
  }
  if (totalMonths > 0) {
    return `${totalMonths} mes${totalMonths !== 1 ? "es" : ""}`;
  }
  if (days > 0) {
    return `${days} día${days !== 1 ? "s" : ""}`;
  }
  return "Recién nacido";
});

Vue.filter("formatDistanceStrict", function (value) {
  return value
    ? formatDistanceStrict(new Date(), parseISO(value), {
        addSuffix: false,
        locale: dateFnsEsp,
      })
        .replace("segundos", "segs")
        .replace("minuto", "min")
        .replace("horas", "hrs")
    : "";
});

Vue.filter("timeSince", function (value) {
  return value
    ? formatDistance(parseISO(value), new Date(), {
        addSuffix: true,
        locale: dateFnsEsp,
      })
    : "Sin fecha";
});

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("formatSize", function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + " MB";
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + " KB";
  }
  return size.toString() + " B";
});
